import api from "@/api";


//列表
export const olitypelist = (data) => {
    return api.axss("post", `/ocm-oil-site/zhuangzhi/page`,data)
  }


  //新增
export const addType = (data) => {
    return api.axss("post", `/ocm-oil-site/zhuangzhi/insert`,data)
  }

  //编辑

  export const updateType=(data)=>{
    return api.axss("post", `/ocm-oil-site/zhuangzhi/update`,data)
  }


   //删除

   export const DelType=(id)=>{
    return api.axss("get", `/ocm-oil-site/zhuangzhi/remove?id=${id}`)
  }


     //获取装置指标

     export const oilSiteTypeModel=(id,source)=>{
      return api.axss("get", `/ocm-oil-site/zhuangzhi/identifiers?id=${id}&source=${source}`)
    }
  

    //获取全部指标

    export const getidFiconPage=()=>{
      return api.axss("get", `/ocm-oil-site/oil-site-identifier-icon/list`)
    }


    
    //编辑指标
    export const batchInsert=(data)=>{
      return api.axss("post", `/ocm-oil-site/zhuangzhi/detail-update`,data)
    }

  